var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { withTranslation } from 'react-i18next';
import { t } from '../../../core/utils/translation-helper';
var CartItemTitle = /** @class */ (function (_super) {
    __extends(CartItemTitle, _super);
    function CartItemTitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CartItemTitle.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("h2", null, this.props.item.getName()),
            React.createElement("span", null,
                this.props.t('cart.list.photos_count', { count: this.props.item.photos.length }),
                ' ',
                "|",
                ' ',
                t('description', this.props.item.product.translations))));
    };
    return CartItemTitle;
}(React.Component));
export default withTranslation()(CartItemTitle);
